export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
import { trackEvent } from "./analytics";
export const STORE_URL = "https://shop.01london.com";
export const FREE_SHIP_PENCE = 7500;

export const gbp = (pence) => `£${(pence / 100).toFixed(2)}`;

export async function fetchProducts() {
  const res = await fetch(`${API_URL}/products`);
  if (!res.ok) throw new Error("Failed to load products");
  return res.json();
}

export async function fetchProduct(handle) {
  const res = await fetch(`${API_URL}/products/${handle}`);
  if (!res.ok) throw new Error("Product not found");
  return res.json();
}

export async function subscribeEmail(email) {
  const res = await fetch(`${API_URL}/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || "Something went wrong");
  return data;
}

// Shopify checkout: per-line selling plans need a form POST to /cart/add.
// GET permalinks with selling_plan are rejected (HTTP 410) by Shopify — tested live.
export const DISCOUNT_CODE = "WELCOME10";

// the 10% welcome discount may only be auto-applied when the visitor actually
// typed their email into the signup (01l_email is set there, and only there)
export const hasEmailDiscount = () => {
  try { return !!localStorage.getItem("01l_email"); } catch (e) { return false; }
};

export function submitShopifyCheckout(items, { newTab = true } = {}) {
  // suppress the newsletter auto-popup for a while — checkout is in progress
  try { localStorage.setItem("01l_checkout_at", String(Date.now())); } catch (e) {}
  const emailCaptured = hasEmailDiscount();
  trackEvent("begin_checkout", {
    value: items.reduce((s, i) => s + (i.price || 0) * (i.qty || 1), 0) / 100,
    ...(emailCaptured ? { coupon: DISCOUNT_CODE } : {}),
    items: items.map((i) => ({
      item_id: i.handle || i.title,
      item_name: i.title,
      price: (i.price || 0) / 100,
      quantity: i.qty || 1,
    })),
  });
  const form = document.createElement("form");
  form.method = "POST";
  form.action = `${STORE_URL}/cart/add`;
  if (newTab) form.target = "_blank";
  const add = (name, value) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };
  add("return_to", emailCaptured ? `/checkout?discount=${DISCOUNT_CODE}` : "/checkout");
  items.forEach((item, i) => {
    add(`items[${i}][id]`, item.variantId);
    add(`items[${i}][quantity]`, item.qty || 1);
    if (item.preorder && item.sellingPlanId) {
      add(`items[${i}][selling_plan]`, item.sellingPlanId);
    }
  });
  document.body.appendChild(form);
  form.submit();
}

export const REVIEW_RATING = "5.0";
export const REVIEW_COUNT = 6;
